const EMPTY_HIDDEN_METRICS = [];

const getSummary = (state) => state.cache.adebifyLtvDetail.summary;
const getTableData = (state) => state.cache.adebifyLtvDetail.table.data;
const getSort = (state) => state.cache.adebifyLtvDetail.table.settings.sort;
const getPagination = (state) =>
  state.cache.adebifyLtvDetail.table.settings.pagination;
const getGraphData = (state) => state.cache.adebifyLtvDetail.graphData;
const getLtvEvaluationPeriod = (state) =>
  state.cache.adebifyLtvDetail.ltvEvaluationPeriod;
const getStatus = (state) => state.cache.adebifyLtvDetail.status;
const getError = (state) => state.cache.adebifyLtvDetail.error;
const getAxis = (state) => state.cache.adebifyLtvDetail.axis;
const getProductAxis = (state) => state.cache.adebifyLtvDetail.productAxis;
const getDimensions = (state) => state.cache.adebifyLtvDetail.dimensions;
const getMetrics = (state) => state.cache.adebifyLtvDetail.metrics;
const getFilters = (state) => state.cache.adebifyLtvDetail.filters;
const getResponseMeta = (state) => state.cache.adebifyLtvDetail.responseMeta;
const getHiddenMetrics = (state) =>
  state.cache.adebifyLtvDetail.responseMeta?.hidden_metrics ?? EMPTY_HIDDEN_METRICS;

export default {
  getSummary,
  getTableData,
  getSort,
  getPagination,
  getGraphData,
  getLtvEvaluationPeriod,
  getStatus,
  getError,
  getAxis,
  getProductAxis,
  getDimensions,
  getMetrics,
  getFilters,
  getResponseMeta,
  getHiddenMetrics,
};
